interface SectionTitleProps {
  eyebrow?: string;
  title: string;
  description?: string;
  align?: 'left' | 'center';
}

export default function SectionTitle({ eyebrow, title, description, align = 'left' }: SectionTitleProps) {
  const isCenter = align === 'center';
  return (
    <div className={`max-w-3xl ${isCenter ? 'mx-auto text-center' : ''}`}>
      {eyebrow ? (
        <span className="inline-flex items-center gap-2 font-label text-xs tracking-[0.2em] text-primary-700 uppercase">
          <span className="h-px w-6 bg-primary-400" />
          {eyebrow}
        </span>
      ) : null}
      <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">
        {title}
      </h2>
      {description ? (
        <p className="mt-3 md:mt-4 font-body text-sm md:text-base leading-relaxed text-foreground-700">
          {description}
        </p>
      ) : null}
    </div>
  );
}